export default __webpack_public_path__ + "static/media/KOD0068-min.e854f248.webp";